var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckoutSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6949 7.46446C25.7662 5.40786 22.2326 4.39247 18.6589 4.58059C15.0852 4.76872 11.6777 6.14949 8.98113 8.50221C6.28455 10.8549 4.45456 14.0437 3.78367 17.559C3.11278 21.0742 3.63973 24.7128 5.28029 27.8933C6.92084 31.0738 9.58029 33.6124 12.8335 35.1035C16.0868 36.5946 19.746 36.952 23.2262 36.1185C26.7065 35.2851 29.8069 33.309 32.0318 30.506C34.2567 27.7031 35.4778 24.2351 35.4997 20.6565",
    stroke: "#051B46",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 20.7632L35.4999 10.0966M35.4999 10.0966L31.9443 13.9753M35.4999 10.0966L39.0554 13.9753",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4806 18.5585L19.167 22.5585V11.5585",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutSvg);
export default __webpack_public_path__ + "static/media/checkoutSvg.e4d24eef9ba2bdd6ed7aa55d6fc32ab0.svg";
export { ForwardRef as ReactComponent };